import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function FinalCTA() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-50 px-4 md:px-6">
      <div className="max-w-[1280px] mx-auto">
        <div className="rounded-[24px] overflow-hidden mb-12">
          <img
            src="https://readdy.ai/api/search-image?query=Lifestyle%20product%20flatlay%20with%20diverse%20fashion%20accessories%20in%20warm%20rust%20and%20cream%20tones%20on%20textured%20linen%20surface%2C%20soft%20natural%20window%20light%2C%20casual%20elegant%20editorial%20style%2C%20aspirational%20composition&width=1800&height=500&seq=final-cta-banner-v2&orientation=landscape&nocache=true"
            alt="Itaobuy Spreadsheet"
            className="w-full h-auto object-cover"
          />
        </div>

        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
            {t('final_cta.title')}
          </h2>
          <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-8">
            {t('final_cta.desc')}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/guida-itaobuy-sheet-2026"
              className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
            >
              {t('cta.vai_guida_completa')}
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
            >
              {t('cta.itaobuy_sheet')}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 rounded-full border-2 border-primary-500 text-primary-500 text-sm font-semibold hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer whitespace-nowrap"
            >
              {t('cta.buy_now')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}